import styled from '@emotion/styled'
import { colors } from '../../__styling/settings/colors'
import { fonts } from '../../__styling/settings/fonts'
import { metrics } from '../../__styling/settings/metrics'
import { breakpoint } from '../../__styling/style-functions'
import { calcRem } from '../../__styling/style-functions/calc-rem'
import { transition } from '../../__styling/style-mixins'
import { themedValue } from '../../__styling/themed-value'

export interface ButtonProps {
    buttonWidth?: 'wide'
}

export const StyledButton = styled('button')<ButtonProps>(
    {
        background: 'transparent',
        fontSize: calcRem(14),
        textTransform: 'uppercase',
        fontWeight: 700,
        cursor: 'pointer',

        [breakpoint('xs')]: {
            flex: '0 0 auto',
        },

        '&:focus': {
            color: colors.white,
            outline: 'none',
        },

        '&:hover': {
            color: colors.white,
        },

        '&:disabled': {
            pointerEvents: 'none',
            cursor: 'not-allowed',
            opacity: 0.5,
        },
    },
    ({ theme, buttonWidth }) =>
        theme.kind === 'thewest' && {
            background: theme.sectionValues.primaryColor,
            color: colors.white,
            fontFamily: fonts.thewest.sansSerif,
            padding:
                buttonWidth === 'wide'
                    ? calcRem(
                          metrics.thewest.margins.sm,
                          metrics.thewest.margins.lg,
                      )
                    : calcRem(metrics.thewest.margins.sm),
            borderRadius: '2px',
            border: 'none',
            flex: '0 0 auto',
            fontSize: calcRem(11),
            ...transition({ properties: ['background', 'color'] }),

            '&:focus': {
                background: colors.thewest.greyKoala,
            },

            '&:hover': {
                background: colors.thewest.greyGorilla,
            },

            [breakpoint('xxs')]: {
                fontSize: calcRem(14),
            },
        },

    ({ theme }) =>
        theme.kind === 'perthnow' && {
            color: colors.perthnow.blueKyanite,
            fontFamily: fonts.perthnow.heading,
            padding: calcRem(metrics.perthnow.margins.sm, 0),
            border: `1px solid ${colors.perthnow.blueKyanite}`,
            width: calcRem(130),
            display: 'block',
            margin: '0 auto',
            ...transition({ properties: ['background', 'color', 'border'] }),

            [breakpoint('xs')]: {
                margin: 0,
            },

            '&:focus': {
                color: colors.white,
                background: colors.perthnow.pinkThulite,
                border: `1px solid ${colors.perthnow.pinkThulite}`,
            },

            '&:hover': {
                background: colors.perthnow.blueKyanite,
                border: `1px solid ${colors.perthnow.blueKyanite}`,
            },
        },

    ({ theme }) =>
        theme.kind === 'sevennews' && {
            background: themedValue(theme, {
                thewest: colors.black,
                perthnow: colors.black,
                sevennews: (section) => section.button.primaryColor,
            }),
            color: colors.white,
            fontFamily: fonts.sevennews.headingAlternative,
            padding: calcRem(metrics.sevennews.margins.sm),
            borderRadius: calcRem(4),
            border: 'none',
            ...transition({ properties: ['background', 'color'] }),
            flex: '0 0 auto',
            fontSize: calcRem(15),

            '&:focus': {
                background: themedValue(theme, {
                    thewest: colors.black,
                    perthnow: colors.black,
                    sevennews: (section) => section.button.hoverColor,
                }),
                textDecoration: 'underline',
            },

            '&:hover': {
                background: themedValue(theme, {
                    thewest: colors.black,
                    perthnow: colors.black,
                    sevennews: (section) => section.button.hoverColor,
                }),
            },
        },
)
